import axios from 'axios'
import { useToast } from 'vue-toastification'

const toast = useToast()

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Add timestamp to prevent caching
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: Date.now()
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response) {
      // Handle specific error codes
      switch (error.response.status) {
        case 401:
          // Unauthorized - redirect to login
          localStorage.removeItem('token')
          window.location.href = '/login'
          toast.error('Sessie verlopen. Log opnieuw in.')
          break
        case 403:
          toast.error('Geen toegang tot deze resource')
          break
        case 404:
          toast.error('Resource niet gevonden')
          break
        case 422:
          // Validation errors
          const validationErrors = error.response.data.errors
          if (validationErrors) {
            Object.values(validationErrors).flat().forEach(msg => {
              toast.error(msg)
            })
          } else {
            toast.error('Validatiefout opgetreden')
          }
          break
        case 500:
          toast.error('Server fout. Probeer het later opnieuw.')
          break
        default:
          toast.error(error.response.data.message || 'Er is een fout opgetreden')
      }
    } else if (error.request) {
      toast.error('Geen verbinding met de server')
    } else {
      toast.error('Er is een fout opgetreden')
    }
    
    return Promise.reject(error)
  }
)

export default api